import React from 'react';
import { Upload } from 'antd';

function FileUpload(props) {
  const { onChange, accept, children } = props;

  return (
    <Upload
      name="file"
      onChange={onChange}
      beforeUpload={() => false}
      accept={accept}
      showUploadList={false}
      maxCount={1}
    >
      {children}
    </Upload>
  );
}
export default FileUpload;
